"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Liyuu Digital Collection',
    organizationId: 'no2yX8ebUOAUFCtALyNA',
    applicationKey: 'liyuu',
    applicationType: 'standalone',
    artistId: 'WtykYOWcQXgrmMokHJPtZy6Z3Hf1',
    version: '1.1',
    ionicAppId: '745bd2fc',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.liyuu',
        appId: '6480279493',
    },
    android: {
        bundleId: 'com.utoniq.liyuu',
    },
    deeplinkUrl: 'https://liyuu.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3564140',
    deeplinkProd: 'liyuu.utoniq.com',
    custom: {
        modules: {
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'collections', 'threads', 'gachas', 'myProfile'],
    },
});
